import React from 'react';

class GoogleLoginView extends React.Component {
  render() {
    return (
      <div
        id="loginGoogle"
        data-width={this.props.width || 400}
        className="login-google"
        data-theme="outline"
      ></div>
    );
  }
}

export default GoogleLoginView;
